export const emptyForm = {
  symbol: '',
  side: 'buy',
  tradeType: 'stock',
  size: '',
  entryPrice: '',
  entryDate: '',
  exitPrice: '',
  exitDate: '',
  stopLoss: '',
  takeProfit: '',
  timeframe: 'medium',
  strategy: '',
  setup: '',
  confidence: '',
  fees: '',
  notes: '',
  thesis: '',
  mistakes: '',
  lessons: '',
  emotions: 'neutral',
  tags: '',
  status: 'open',
};

export const EMOTION_OPTIONS = [
  { value: 'confident', label: 'Confident', color: 'text-green-600' },
  { value: 'calm', label: 'Calm', color: 'text-blue-600' },
  { value: 'neutral', label: 'Neutral', color: 'text-gray-600' },
  { value: 'anxious', label: 'Anxious', color: 'text-yellow-600' },
  { value: 'fearful', label: 'Fearful', color: 'text-orange-600' },
  { value: 'greedy', label: 'Greedy', color: 'text-red-600' },
  { value: 'fomo', label: 'FOMO', color: 'text-purple-600' },
];

export const SETUP_OPTIONS = [
  'Breakout', 'Pullback', 'Reversal', 'Range', 'Trend Following',
  'Mean Reversion', 'Momentum', 'Gap Fill', 'Earnings Play', 'News Catalyst',
  'Technical Pattern', 'AI Suggestion', 'Other',
];
